import { GET_DOCUMENTO_BY_ID } from "common/utils/documentos"
import notification from "common/utils/notification"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { globalSelector } from "routes/globalSlice"
import { useCurrency } from "../../../common/hooks/useCurrency"
import { setCurrency } from "../../Documentos/redux/documentosSlice"
import { TIPO_DOCUMENTOS_TITLE_SINGLE } from "../constants"
import mapArticuloFromDocumento from "../mappers/mapArticulosFromDocumento"
import { newDocumentoSelector } from "../redux/selectors/newDocumentoSelectors"
import {
  asociateDocumentos,
  convertAsociateDocumentos,
  recalculate,
} from "../redux/slices/newDocumentoSlice"
import mergeRepeatedArticulos from "../utils/mergeRepeatedArticulos"

const fetchProductos = async (
  documentos: $TSMigrationFixMe,
  documentoId: $TSMigrationFixMe
) => {
  const getById = GET_DOCUMENTO_BY_ID[documentoId]
  const allDocumentosPromises = documentos.map((doc: $TSMigrationFixMe) =>
    getById(doc.id)
  )

  const allDocumentos = await Promise.all(allDocumentosPromises)

  const allArticulos: $TSMigrationFixMe = []
  allDocumentos.forEach(({ data }) => {
    allArticulos.push(...data.articuloDocumentos)
  })

  return allArticulos
}

const useAsociarDocumentos = ({ onHide }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { isLibrado } = useSelector(newDocumentoSelector)
  const { tiposImpuestosArticulos } = useSelector(globalSelector)
  const {
    tipoDocumento,
    tipoDocumentoAsociadoId,
    documentosAsociadosId,
    documentosAsociados,
  } = useSelector(newDocumentoSelector)
  const { getAbreviatura } = useCurrency()
  const [documentosSelectedIds, setDocumentosSelectedIds] = useState(
    new Set(documentosAsociadosId)
  )
  const [documentosSelected, setDocumentosSelected] =
    useState(documentosAsociados)
  const [currentTipoDocumentoId, setCurrentTipoDocumentoId] = useState(
    tipoDocumentoAsociadoId
  )
  const [asociandoDocumentos, setAsociandoDocumentos] = useState(false)

  const dispatch = useDispatch()

  const handleOnSelectDocumento = ({
    documento: documentoSeleccionado,
    tipoDocumentoId,
  }: $TSMigrationFixMe) => {
    if (
      currentTipoDocumentoId !== null &&
      tipoDocumentoId !== currentTipoDocumentoId
    ) {
      return notification.errorServidor({
        body: `${t("notification.documentSelectedOnlyOneType")}`,
      })
    }

    setCurrentTipoDocumentoId(tipoDocumentoId)
    let newDocumentos = [...documentosSelected]

    if (documentosSelectedIds.has(documentoSeleccionado.id)) {
      documentosSelectedIds.delete(documentoSeleccionado.id)
      newDocumentos = newDocumentos.filter(
        (newDocumento) => newDocumento.id !== documentoSeleccionado.id
      )
    } else {
      documentosSelectedIds.add(documentoSeleccionado.id)
      newDocumentos.push(documentoSeleccionado)
    }

    if (documentosSelectedIds.size === 0) {
      setCurrentTipoDocumentoId(null)
    }

    setDocumentosSelectedIds(new Set([...documentosSelectedIds]))
    setDocumentosSelected(newDocumentos)
  }

  const clearDocumentosAsociados = () => {
    dispatch(
      // @ts-expect-error TS(2345): Argument of type...
      asociateDocumentos({
        productos: [],
        documentosAsociados: [],
        tipoDocumentoAsociadoId: null,
        documentosAsociadosMsg: null,
        documentosAsociadosId: [],
      })
    )
    dispatch(recalculate())

    onHide()
  }

  const handleAsociarDocumentos = () => {
    if (!documentosSelected.length) {
      return clearDocumentosAsociados()
    }
    const areServeralDocuments = documentosSelected.length > 1
    const currencyFirstDocument = documentosSelected[0]?.divisa
    const allCoinsAreEqual = documentosSelected.every(
      (document: $TSMigrationFixMe) => document.divisa === currencyFirstDocument
    )

    setAsociandoDocumentos(true)
    fetchProductos(documentosSelected, currentTipoDocumentoId)
      .then((productos) => {
        const mappedProductos = mapArticuloFromDocumento(
          productos,
          tiposImpuestosArticulos,
          isLibrado
        )
        // @ts-expect-error TS(2345): Argument of type 'any[]' is not assignable to para...
        const mergedProductos = mergeRepeatedArticulos(mappedProductos)
        const documentosAsociadosId = [...documentosSelectedIds]
        const numeroDocumentos = documentosSelected
          .map(({ serie, numero }: $TSMigrationFixMe) => `${serie}-${numero}`)
          .join(`, `)
        const documentosAsociadosMsg = `${
          TIPO_DOCUMENTOS_TITLE_SINGLE(t)[currentTipoDocumentoId]
        }: ${numeroDocumentos}`

        dispatch(
          // @ts-expect-error TS(2345): Argument of type...
          asociateDocumentos({
            productos: mergedProductos,
            documentosAsociados: documentosSelected,
            tipoDocumentoAsociadoId: currentTipoDocumentoId,
            documentosAsociadosMsg,
            documentosAsociadosId,
          })
        )
        dispatch(recalculate())
        onHide()
      })
      .finally(() => {
        if (areServeralDocuments) {
          if (allCoinsAreEqual) {
            // @ts-expect-error TS(2339): Property 'abreviatura' does not exist on type 'und...
            const { abreviatura } = getAbreviatura(currencyFirstDocument)
            dispatch(setCurrency(abreviatura))
          }
        } else {
          // @ts-expect-error TS(2339): Property 'abreviatura' does not exist on type 'und...
          const { abreviatura } = getAbreviatura(currencyFirstDocument)
          dispatch(setCurrency(abreviatura))
        }
        setAsociandoDocumentos(false)
      })
  }

  const handleAsociarDocumentosBy = async (
    docs: $TSMigrationFixMe,
    tipoId: $TSMigrationFixMe
  ) => {
    const newDocumentosAsociadosId = docs.map(
      (newDocumento: $TSMigrationFixMe) => newDocumento.id
    )

    setCurrentTipoDocumentoId(tipoId)
    setDocumentosSelectedIds(new Set(newDocumentosAsociadosId))
    setDocumentosSelected(docs)

    const numeroDocumentos = docs
      .map(({ serie, numero }: $TSMigrationFixMe) => `${serie}-${numero}`)
      .join(`, `)
    const documentosAsociadosMsg = `${
      TIPO_DOCUMENTOS_TITLE_SINGLE(t)[tipoId]
    }: ${numeroDocumentos}`

    try {
      dispatch(
        // @ts-expect-error TS(2345): Argument of type...
        asociateDocumentos({
          documentosAsociados: docs,
          tipoDocumentoAsociadoId: tipoId,
          documentosAsociadosMsg,
          documentosAsociadosId: newDocumentosAsociadosId,
        })
      )

      dispatch(recalculate())
    } catch (e) {
      notification.errorServidor({
        body: `${t("notification.errorOcurred")}`,
      })
    }
  }

  const handleConvertAsociarDocumentosBy = async (
    docs: $TSMigrationFixMe,
    tipoId: $TSMigrationFixMe
  ) => {
    const newDocumentosAsociadosId = docs.map(
      (newDocumento: $TSMigrationFixMe) => newDocumento.id
    )

    setCurrentTipoDocumentoId(tipoId)
    setDocumentosSelectedIds(new Set(newDocumentosAsociadosId))
    setDocumentosSelected(docs)

    const numeroDocumentos = docs
      .map(({ serie, numero }: $TSMigrationFixMe) => `${serie}-${numero}`)
      .join(`, `)
    const documentosAsociadosMsg = `${
      TIPO_DOCUMENTOS_TITLE_SINGLE(t)[tipoId]
    }: ${numeroDocumentos}`

    try {
      dispatch(
        // @ts-expect-error TS(2345): Argument of type...
        convertAsociateDocumentos({
          documentosAsociados: docs,
          tipoDocumentoAsociadoId: tipoId,
          documentosAsociadosMsg,
          documentosAsociadosId: newDocumentosAsociadosId,
        })
      )

      dispatch(recalculate())
    } catch (e) {
      notification.errorServidor({
        body: `${t("notification.errorOcurred")}`,
      })
    }
  }

  return {
    asociandoDocumentos,
    documentosSelectedIds,
    currentTipoDocumentoId,
    documentosSelected,
    tipoDocumento,
    handleAsociarDocumentos,
    handleAsociarDocumentosBy,
    handleConvertAsociarDocumentosBy,
    handleOnSelectDocumento,
  }
}

export default useAsociarDocumentos
